export const SETTING_GET_OPENING_HOURS_REQUEST = 'SETTING_GET_OPENING_HOURS_REQUEST';
export const SETTING_GET_OPENING_HOURS_FAIL = 'SETTING_GET_OPENING_HOURS_FAIL';
export const SETTING_GET_OPENING_HOURS_SUCCESS = 'SETTING_GET_OPENING_HOURS_SUCCESS';
export const SETTING_VALIDATE_OPENING_HOURS_STATE = 'SETTING_VALIDATE_OPENING_HOURS_STATE';
export const RESTAURANT_CLOSED_STATE = 'RESTAURANT_CLOSED_STATE';
export const UNAVAILABLE_ORDER_TYPE = 'UNAVAILABLE_ORDER_TYPE';
export const UNAVAILABLE_ORDER_TYPE_WITH_SELECTED_TIME = 'UNAVAILABLE_ORDER_TYPE_WITH_SELECTED_TIME';
export const CLEAR_UNAVAILABLE_ORDER_TYPE_WITH_SELECTED_TIME='CLEAR_UNAVAILABLE_ORDER_TYPE_WITH_SELECTED_TIME';